<template>
  <article class="ticket-item" type="button" @click="$emit('click-status', item)" tabindex="0">
    <div class="ticket-main">
      <div class="ticket-top">
        <span class="category-chip">{{ item.category || '-' }}</span>
        <strong>{{ item.ticketNo || item.aqId || item.outline }}</strong>
      </div>
      <p>{{ item.outline }}</p>
    </div>

    <div class="ticket-meta">
      <span class="status-badge" :class="statusClass(item.status)">
        {{ statusText(item.status) }}
      </span>
      <time>{{ item.time || '-' }}</time>
    </div>
  </article>
</template>

<script>
export default {
  name: 'TicketCard',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    statusText(s) {
      const key = String(s || '').toUpperCase()
      if (key === 'NEW' || key === '0') return this.$t('support_status_unreplied')
      if (key === 'PROCESSING' || key === '4') return this.$t('support_status_pending_review')
      if (key === 'HANDLED' || key === '1') return this.$t('support_status_replied')
      if (key === 'RESOLVED' || key === 'CANCELLED' || key === '2' || key === '3') return this.$t('support_status_resolved')
      return typeof s === 'string' ? s : this.$t('support_status_unreplied')
    },
    statusClass(s) {
      const key = String(s || '').toUpperCase()
      if (key === 'NEW' || key === '0') return 'status-new'
      if (key === 'HANDLED' || key === '1') return 'status-handled'
      if (key === 'RESOLVED' || key === 'CANCELLED' || key === '2' || key === '3') return 'status-resolved'
      if (key === 'PROCESSING' || key === '4') return 'status-processing'
      return 'status-handled'
    }
  }
}
</script>

<style scoped>
.ticket-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 12px;
  border: 1px solid var(--support-line);
  border-radius: 8px;
  padding: 14px 16px;
  color: inherit;
  text-align: left;
  background: #fff;
  cursor: pointer;
  outline: none;
  transition: border-color .16s ease, background .16s ease;
}

.ticket-item:hover,
.ticket-item:focus {
  border-color: var(--support-primary-line);
  background: #fbfdff;
}

.ticket-main {
  min-width: 0;
}

.ticket-top {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.ticket-top strong {
  overflow: hidden;
  color: var(--support-text);
  font-size: .175rem;
  line-height: 24px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ticket-item p {
  display: -webkit-box;
  margin: 8px 0 0;
  overflow: hidden;
  color: #5d6b7c;
  font-size: .175rem;
  line-height: 23px;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.ticket-meta {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-direction: column;
  gap: 8px;
  min-width: 1.24rem;
  color: var(--support-muted);
  font-size: .175rem;
  line-height: 20px;
  text-align: right;
}

.category-chip,
.status-badge {
  display: inline-flex;
  align-items: center;
  height: 26px;
  border-radius: 13px;
  padding: 0 10px;
  font-size: .175rem;
  line-height: 26px;
  white-space: nowrap;
}

.category-chip {
  max-width: 132px;
  overflow: hidden;
  color: var(--support-primary-strong);
  text-overflow: ellipsis;
  background: var(--support-primary-soft);
}

.status-badge {
  color: var(--support-primary-strong);
  background: var(--support-primary-soft);
}

.status-new {
  color: #e74c3c;
  background: #fff1ef;
}

.status-processing {
  color: #a96600;
  background: #fff6df;
}

.status-handled,
.status-resolved {
  color: #18a765;
  background: #eaf9f1;
}

@media (max-width: 768px) {
  .ticket-item {
    grid-template-columns: 1fr;
    gap: .22rem;
    border-color: #d9e4f1;
    border-radius: .14rem;
    padding: .24rem;
    background: #fff;
  }

  .ticket-main {
    min-width: 0;
  }

  .ticket-top {
    align-items: center;
    gap: .14rem;
  }

  .ticket-top strong {
    flex: 1;
    min-width: 0;
    color: var(--support-text);
    font-size: .32rem;
    font-weight: 800;
    line-height: .42rem;
  }

  .ticket-item p {
    margin: .14rem 0 0;
    color: #40506a;
    font-size: .28rem;
    line-height: .4rem;
    -webkit-line-clamp: 2;
  }

  .ticket-meta {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    min-width: 0;
    gap: .2rem;
    margin-top: .02rem;
    font-size: .26rem;
    line-height: .34rem;
    text-align: left;
  }

  .category-chip,
  .status-badge {
    height: .48rem;
    border-radius: .24rem;
    padding: 0 .18rem;
    font-size: .24rem;
    line-height: .48rem;
  }

  .category-chip {
    max-width: 2rem;
    flex: 0 0 auto;
  }

  .status-badge {
    order: 1;
  }

  .ticket-meta time {
    order: 2;
    overflow: hidden;
    color: #687890;
    font-size: .26rem;
    line-height: .34rem;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
